/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';
import { Notification } from 'components/CustomNotification';
import axios from 'components/Axios';
import { t } from 'i18next';
import {
  userLogin,
  SendMail,
  ValidateMail,
  ValidateMoileOtp,
  SendMobileOtp,
  UserNameCreate,
  UserGoogleSignup,
  ResetPassApi,
  VerifyResetPass,
  ChangePassword,
  ValidateUser,
  VerifyEmailAndPhoneSettingsApi,
  ChangeUserRole,
  handleFollowAutoAccept,
  GetUpdateUsernameOTP,
  ChangeUserName,
  UserAppleSignup,
} from '../services/LoginService';
import { getProfile, getProfileByuserId } from './ProfileSlice';
import { ClearLoading, SetLoading } from 'redux/services/LoadingService';
import { getCountrLocation, Logout } from 'redux/APIEndPoint';
import { BaseUrl, localIP } from 'environment';
import { registerPushNotifications } from 'components/RegisterPushNotifications';

const ErrorText = t('errortxt');
export const LoginSlice = createSlice({
  name: 'login',
  initialState: {
    getTheme: '',
    countryCode: '',
    authData: '',
    authActionsData: '',
    // loginResponse: '',
    CLEAR_REDUX_STORE: '',
  },

  reducers: {
    getTheme: (state, action) => {
      state.getTheme = action.payload;
    },
    GetCountryCode: (state, action) => {
      state.countryCode = action.payload;
    },
    UpdateAuthData: (state, action) => {
      state.authData = action.payload;
    },
    UpdateAuthActionsData: (state, action) => {
      state.authActionsData = action.payload;
    },
    // GetLoginResponse: (state, action) => {
    //   state.loginResponse = action.payload;
    // },
    HandleClearRedux: (state) => {
      state.CLEAR_REDUX_STORE = '';
    },
  },
});

export const Createlogin = (data, type) => async (dispatch) => {
  const payloadEmail = {
    userEmail: data.email,
    userPassword: data.password,
  };

  const payloadMobile = {
    phoneNo: data.phcode,
    userPassword: data.password,
  };
  userLogin(type === 'email' ? payloadEmail : payloadMobile, type)
    .then((response) => {
      if (response?.success) {
        const { token } = response?.data || '';
        localStorage.setItem('token', token);
        // localStorage.setItem('email', userEmail || '');
        // localStorage.setItem('user_id', userId);
        // localStorage.setItem('username', username);
        // dispatch(GetLoginResponse(response?.data));
        dispatch(getProfile(response?.data));
        if(response?.data?.username) {
          registerPushNotifications();
        }
        setTimeout(() => {
          const username = response?.data?.username;
          const trimmedUsername =
            username?.length > 20 ? username?.slice(0, 20) + '...' : username;
            if(trimmedUsername) {
              Notification('success', `Welcome Back, @${trimmedUsername}`);
            }
        }, 1000);
      }
      if (!response?.data?.hasUserName) {
        dispatch(UpdateAuthActionsData(response?.data));
      }
      dispatch(UpdateAuthData(response));
    })
    .catch((err) => {
      dispatch(UpdateAuthData(err.response?.data));
      Notification(
        'error',
        err.response?.data?.message || err?.message || ErrorText
      );
    });
};

export const SendMailOtp =
  (data, value, hideUpdateResponse) => async (dispatch) => {
    const payload = {
      userEmail: data.email,
      signup: value,
      otpType: data.otpType,
    };
    SendMail(payload)
      .then((response) => {
        const loginState = {
          email: data.email,
          signup: value,
          otpType: data.otpType,
          sid: response?.data?.data?.sid,
          // pid: response?.data?.data?.pid,
          password: data.password,
          type: 'email',
        };
        dispatch(UpdateAuthActionsData(loginState));
        !hideUpdateResponse && dispatch(UpdateAuthData(response?.data));
        Notification('success', response?.data?.message);
      })
      .catch((err) => {
        dispatch(UpdateAuthData(err.response?.data));
        Notification('error', err.response?.data?.message || ErrorText);
      });
  };

export const VerifyEMailOtp = (payload) => async (dispatch) => {
  ValidateMail(payload)
    .then((response) => {
      dispatch(UpdateAuthActionsData(response?.data));
      dispatch(UpdateAuthData(response?.data));
      Notification('success', response?.data?.message);
    })
    .catch((err) => {
      dispatch(UpdateAuthData(err.response?.data));
      Notification('error', err.response?.data?.message || ErrorText);
    });
};

export const MobileOtp =
  (data, value, hideUpdateResponse) => async (dispatch) => {
    const payload = {
      phoneNo: data?.phcode,
      signup: value,
      otpType: 'register',
    };
    SendMobileOtp(payload)
      .then((response) => {
        const loginState = {
          phoneNo: data.phcode,
          signup: value,
          otpType: 'register',
          sid: response?.data?.data?.sid,
          password: data.password,
          type: 'mobile',
        };
        dispatch(UpdateAuthActionsData(loginState));
        !hideUpdateResponse && dispatch(UpdateAuthData(response?.data));
        Notification('success', response?.data?.message);
      })
      .catch((err) => {
        dispatch(UpdateAuthData(err.response?.data));
        Notification('error', err.response?.data?.message || ErrorText);
      });
  };

export const VerifyMobileOtp = (payload) => async (dispatch) => {
  ValidateMoileOtp(payload)
    .then((response) => {
      dispatch(UpdateAuthData(response?.data));
      dispatch(UpdateAuthActionsData(response?.data));
    })
    .catch((err) => {
      Notification('error', err.response?.data?.message || ErrorText);
    });
};

export const UserNameCreateApi = (data, UserId) => async () => {
  return UserNameCreate(data, UserId);
};

export const handleGoogleSignup = (payload) => async (dispatch) => {
  return UserGoogleSignup(payload)
    .then((response) => {
      if (response?.success) {
        setTimeout(() => {
          const username = response?.data?.username;
          const trimmedUsername =
            username?.length > 20 ? username?.slice(0, 20) + '...' : username;
            if(trimmedUsername) {
              Notification('success', `Welcome, @${trimmedUsername}`);
            }
        }, 1000);
        const { token } = response?.data || '';
        localStorage.setItem('token', token);
        dispatch(getProfile(response?.data));
        registerPushNotifications();
      }
      dispatch(UpdateAuthData(response));
      return response;
    })
    .catch((err) => {
      dispatch(UpdateAuthData(err.response?.data));
      Notification(
        'error',
        err.response?.data?.message || err?.message || ErrorText
      );
      return err;
    });
};

export const handleAppleSignup = (payload) => async (dispatch) => {
  return UserAppleSignup(payload)
    .then((response) => {
      if (response?.success) {
        setTimeout(() => {
          const username = response?.data?.username;
          const trimmedUsername =
            username?.length > 20 ? username?.slice(0, 20) + '...' : username;
            if(trimmedUsername) {
              Notification('success', `Welcome, @${trimmedUsername}`);
            }
        }, 1000);
        const { token } = response?.data || '';
        localStorage.setItem('token', token);
        dispatch(getProfile(response?.data));
        registerPushNotifications();
      }
      dispatch(UpdateAuthData(response));
      return response;
    })
    .catch((err) => {
      dispatch(UpdateAuthData(err.response?.data));
      Notification(
        'error',
        err.response?.data?.message || err?.message || ErrorText
      );
      return err;
    });
};

export const ValidateUserApi =
  (data, userId, isDisable) => async (dispatch) => {
    ValidateUser(data, userId)
      .then((response) => {
        if (!isDisable) {
          dispatch(UpdateAuthData(response?.data));
          dispatch(getProfileByuserId(userId));
        }
        Notification('success', response?.data?.message);
      })
      .catch((err) => {
        !isDisable && dispatch(UpdateAuthData(err.response?.data));
        Notification('error', err.response?.data?.message || ErrorText);
      });
  };

export const handleGetUpdateUsernameOTP = (payload) => async () => {
  return GetUpdateUsernameOTP(payload);
};

export const handleChangeUserName = (payload) => async () => {
  return ChangeUserName(payload);
};

export const ChangeUserRoleApi = (data, userId) => async () => {
  return ChangeUserRole(data, userId);
};

export const DeleteAccountApi = (userId) => async (dispatch) => {
  dispatch(SetLoading());
  try {
    const promise = axios.delete(`user/${userId}`);
    const dataPromise = promise.then((response) => response);
    return dataPromise;
  } catch (err) {
    Notification('error', err.response?.data?.message || ErrorText);
  } finally {
    setTimeout(() => {
      dispatch(ClearLoading());
    }, [2000]);
  }
};

export const handleFollowAutoAcceptApi = (data) => async () => {
  return handleFollowAutoAccept(data);
};

export const ResetPasswordApi = (data, value) => async () => {
  const payload = {
    pid: value.pid,
    sid: data?.sid,
    otp: value.otp,
    password: value.password,
  };
  const EmailData = { ...payload, userEmail: data?.email };
  const MblData = { ...payload, phoneNo: data?.phcode };

  return ResetPassApi(data?.type === 'email' ? EmailData : MblData, data?.type);
};

export const ChangePasswordApi = (data, userId) => async (dispatch) => {
  const payload = {
    confirmPassword: data.confirm_password,
    newPassword: data.new_password,
    oldPassword: data.current_password,
  };
  ChangePassword(payload, userId)
    .then((response) => {
      dispatch(UpdateAuthData(response?.data));
      Notification('success', response?.data?.message);
    })
    .catch((err) => {
      dispatch(UpdateAuthData(err.response?.data));
      Notification('error', err.response?.data?.message || ErrorText);
    });
};

export const VerifyPhoneAndEmail =
  (data, userId) => async (dispatch, getState) => {
    VerifyEmailAndPhoneSettingsApi(data, userId)
      .then((response) => {
        const state = getState();
        dispatch(UpdateAuthData(response?.data));
        dispatch(getProfileByuserId(state?.ProfileSlice?.getProfile?.userId));
        Notification('success', response?.data?.message);
      })
      .catch((err) => {
        dispatch(UpdateAuthData(err.response?.data));
        Notification('error', err.response?.data?.message || ErrorText);
      });
  };

export const VerifyOtpResetPassword = (data, value) => async () => {
  const payload = {
    sid: data?.sid,
    otp: value.otp,
  };
  // const EmailData = { ...payload, userEmail: data?.authActionsData?.email };
  const MblData = { ...payload, phoneNo: data?.phcode };
  return VerifyResetPass(
    data?.type === 'email' ? payload : MblData,
    data?.type
  );
};

export const changeMode = (data) => async (dispatch) => {
  dispatch(getTheme(data));
};

export const CountryCode = () => async (dispatch) => {
  // 'https://ipapi.co/json/'
  await axios
    .get(
      getCountrLocation +
        (BaseUrl.includes('localhost') || BaseUrl.includes('qa.wafynet')
          ? `/${localIP}`
          : '')
    )
    .then((response) => {
      const data = response.data;
      dispatch(GetCountryCode(data));
    });
  // let samplePayload = {
  //   city: 'Dubai',
  //   region: 'Dubai',
  //   region_code: 'DU',
  //   country: 'AE',
  //   country_name: 'United Arab Emirates',
  //   country_code: 'AE',
  //   country_capital: 'Abu Dhabi',
  //   country_tld: '.ae',
  //   latitude: 25.0734,
  //   longitude: 55.2979,
  //   timezone: 'Asia/Dubai',
  //   country_calling_code: '+971',
  //   currency: 'AED',
  //   currency_name: 'Dirham',
  //   country_area: 82880,
  // };
  // dispatch(GetCountryCode(samplePayload));
};

export const handleClearAllValue = () => async (dispatch) => {
  await axios
    .post(Logout)
    .then((res) => {
      // dispatch(HandleClearRedux());
      return res;
    })
    .catch(() => {
      return null;
    });
};

export const {
  getTheme,
  GetCountryCode,
  UpdateAuthData,
  UpdateAuthActionsData,
  // GetLoginResponse,
  HandleClearRedux,
} = LoginSlice.actions;
export default LoginSlice.reducer;
